import { listOrgEnrollments } from "./enrollmentHelpers"
import { listOrgCertificates } from "./certHelpers"
import { listPrograms } from "./programHelpers"

// Program Performance rows — Learners/Progress/Completion/Credentials all
// aggregate across a program's bundled courseIds, same pattern as Product
// Performance. A program with no courses assigned yet legitimately shows
// zeros rather than fabricated numbers.
export const computeProgramPerformance = async (orgId) => {
  const [{ enrollments }, { certificates }, { programs }] = await Promise.all([
    listOrgEnrollments(orgId),
    listOrgCertificates(orgId),
    listPrograms(orgId),
  ])

  const activePrograms = programs?.filter((p) => p?.status !== "archived") || []

  const rows = activePrograms?.map((program) => {
    const bundledIds = program?.courseIds || []
    const programEnrollments = enrollments?.filter((e) => bundledIds?.includes(e?.courseId)) || []
    const learnerIds = new Set(programEnrollments?.map((e) => e?.userId))

    const avgProgress = programEnrollments?.length
      ? Math.round(
          programEnrollments?.reduce((sum, e) => sum + (e?.progressPercent || 0), 0) / programEnrollments.length
        )
      : 0

    const completedCount = programEnrollments?.filter((e) => (e?.progressPercent || 0) >= 100)?.length || 0
    const completionRate = programEnrollments?.length ? Math.round((completedCount / programEnrollments.length) * 100) : 0

    const programCredentials = certificates?.filter((c) => bundledIds?.includes(c?.courseId))?.length || 0

    return {
      id: program?.programId,
      name: program?.title || "Untitled Program",
      type: program?.programType || "Program",
      learners: learnerIds.size,
      progress: avgProgress,
      completion: completionRate,
      credentials: programCredentials,
      analyticsTab: "intelligence-programs",
    }
  })

  return rows?.sort((a, b) => b?.learners - a?.learners)
}